import React, { Fragment } from "react";
import { Nullable } from "../../../../types/utils";
import { OrderCostingVersion, TApiOrderDetails } from "../../../api/endpoints/Order";
import OrderCostSummaryPdfV1 from "./OrderCostSummaryPdfV1";
import OrderCostSummaryPdfV2 from "./OrderCostSummaryPdfV2";
import ReactPDF from "@react-pdf/renderer";
import { User } from "../../../entities/User";
import OrderCostSummaryPdfV3 from "./OrderCostSummaryPdfV3";
import OrderCostSummaryPdfV4 from "./OrderCostSummaryPdfV4";
import OrderCostSummaryPdfV5 from "./OrderCostSummaryPdfV5";
import OrderCostSummaryPdfV6 from "./OrderCostSummaryPdfV6";

interface IProps {
  user: User;
  order: TApiOrderDetails;
  currentCostingVersion: Nullable<OrderCostingVersion>;
  styles: ReactPDF.Styles;
  annualTotalCostFootnoteRef?: string;
}

const OrderCostSummaryPdf = (props: IProps) => {
  const {
    user,
    order,
    currentCostingVersion,
    styles,
    annualTotalCostFootnoteRef
  } = props;
  const { version } = order.cost;

  return (
    <Fragment>
      {
        version === 'v1' &&
        <OrderCostSummaryPdfV1
          cost={order.cost}
          orderCategory={order.category}
          styles={styles}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }

      {
        version === 'v2' &&
        <OrderCostSummaryPdfV2
          user={user}
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          styles={styles}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }

      {
        version === 'v3' &&
        <OrderCostSummaryPdfV3
          user={user}
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          styles={styles}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }

      {
        version === 'v4' &&
        <OrderCostSummaryPdfV4
          user={user}
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          styles={styles}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }

      {
        version === 'v5' &&
        <OrderCostSummaryPdfV5
          user={user}
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          styles={styles}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }

      {
        version === 'v6' &&
        <OrderCostSummaryPdfV6
          user={user}
          cost={order.cost}
          currentCostingVersion={currentCostingVersion}
          orderStatus={order.status}
          orderCategory={order.category}
          styles={styles}
          annualTotalCostFootnoteRef={annualTotalCostFootnoteRef}
        />
      }
    </Fragment>
  )
}

export default OrderCostSummaryPdf;
